import React, { useEffect, useState } from "react";
import { Gift, X } from "lucide-react";

const STORAGE_KEY = "drillflo_band_camp_giveaway_banner_dismissed_2026";
const GIVEAWAY_URL = "https://www.drillflo.com/band-camp-giveaway";
/** Hide the banner once the promotion period has ended (entries close Sep 8). */
const ENDS_AT = new Date("2026-09-09T03:59:59.000Z"); // Sep 8 11:59pm ET

export default function BandCampGiveawayBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (Date.now() > ENDS_AT.getTime()) return;
    try {
      if (localStorage.getItem(STORAGE_KEY) === "1") return;
    } catch {
      // ignore
    }
    setVisible(true);
  }, []);

  const dismiss = () => {
    setVisible(false);
    try {
      localStorage.setItem(STORAGE_KEY, "1");
    } catch {
      // ignore
    }
  };

  if (!visible) return null;

  return (
    <div className="mb-6 rounded-xl border border-orange-200 bg-gradient-to-r from-orange-50 to-amber-50 px-4 py-3 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
      <div className="flex items-start gap-3 min-w-0">
        <div className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-orange-500 text-white">
          <Gift className="h-5 w-5" />
        </div>
        <div className="min-w-0">
          <p className="text-sm font-semibold text-orange-950">
            The DrillFlo 2026 Band Camp Giveaway — win a $50 gift card!
          </p>
          <p className="mt-0.5 text-sm text-orange-900/80">
            Post your band on the field, tag DrillFlo, and use
            #DrillFloOnTheField. Entries end September 8th.
          </p>
        </div>
      </div>
      <div className="flex items-center gap-3 shrink-0 self-end sm:self-center">
        <a
          href={GIVEAWAY_URL}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center justify-center rounded-lg bg-orange-600 px-4 py-2 text-sm font-medium text-white hover:bg-orange-700 transition-colors"
        >
          How to enter
        </a>
        {/* <button
          type="button"
          onClick={dismiss}
          className="rounded-lg p-2 text-orange-800/70 hover:bg-orange-100 hover:text-orange-950 transition-colors"
          aria-label="Dismiss giveaway banner"
        >
          <X className="h-4 w-4" />
        </button> */}
      </div>
    </div>
  );
}
